var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-outer"},[_c('h3',[_vm._v("FutureNet Products Packs")]),_vm._v(" "),_c('h3',[_vm._v("Total amount to FutureNet: "+_vm._s(_vm.amount))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c2b128","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/section/content/fnproductpacks/Header.vue
// module id = Tgd4
// module chunks = 0